import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import './ProgressBarAnimated.css';

const ProgressBarAnimated = (props) => {
    const { min,max,now,percentage,title,unit,variant } = props;

    return (
        <div id='div-progressbar-animated' title={`${now + ' ' + unit}`}>
            <h6 className='progressbar-title'>{title}</h6>
            <ProgressBar className='progressbar-bootstrap-component' animated variant={variant} now={percentage} label={`${now + ' ' + unit}`} />
            <a className='progressbar-beginning-limit'>{min} {unit}</a>
            <a className='progressbar-end-limit'>{max} {unit}</a>
        </div>
    );
};

export default ProgressBarAnimated;